import { FormControl, Select as NBSelect } from 'native-base'
import { forwardRef } from 'react'

import { Select as BaseSelect } from '../../atoms/Select'
import { layoutPropsKeys } from './constants'
import type { FieldSelectProps } from './types'

import { useMemo } from '~hooks'

export const Select = forwardRef<typeof NBSelect, FieldSelectProps>(
  (
    { isDisabled, isRequired, isInvalid = false, label, helperText, errorMessage, values, ...props },
    ref
  ) => {
    const layoutProps = useMemo(
      () =>
        Object.fromEntries(Object.entries(props).filter(([key]) => layoutPropsKeys.includes(key))),
      [props]
    )
    const selectProps = useMemo(
      () =>
        Object.fromEntries(Object.entries(props).filter(([key]) => !layoutPropsKeys.includes(key))),
      [props]
    )

    return (
      <FormControl isRequired={isRequired} isInvalid={isInvalid || Boolean(errorMessage)} {...layoutProps}>
        {label && (
          <FormControl.Label
            _text={{
              fontSize: 'sm',
              fontWeight: '600',
              color: 'gray.700',
              mb: 2,
            }}
          >
            {label}
          </FormControl.Label>
        )}
        <BaseSelect isError={Boolean(errorMessage)} values={values} {...selectProps} ref={ref} />
        {helperText && (
          <FormControl.HelperText
            _text={{
              fontSize: 'xs',
              color: 'gray.500',
              mt: 1,
            }}
          >
            {helperText}
          </FormControl.HelperText>
        )}
        <FormControl.ErrorMessage
          _text={{
            fontSize: 'xs',
            color: 'error.600',
            fontWeight: '500',
            mt: 1,
          }}
        >
          {errorMessage || ' '}
        </FormControl.ErrorMessage>
      </FormControl>
    )
  }
)
